import { render, staticRenderFns } from "./ImportTab.vue?vue&type=template&id=1420ed0e&scoped=true&"
import script from "./ImportTab.vue?vue&type=script&lang=ts&"
export * from "./ImportTab.vue?vue&type=script&lang=ts&"
import style0 from "./ImportTab.vue?vue&type=style&index=0&id=1420ed0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1420ed0e",
  null
  
)

export default component.exports